// extracted by mini-css-extract-plugin
export default {"container":"styles_container__KEUTL","img":"styles_img__rRRQn"};